import angular from 'angular';
import uiRouter from 'angular-ui-router';
import playerEditComponent from './playerEdit.component';

let playerEditModule = angular.module('playerEdit', [
  uiRouter
]).config(($stateProvider) => {
	'ngInject';

	$stateProvider.state('player-edit', {
		url: '/players/edit/:id',
		component: 'playerEdit',
		data: {pageTitle: 'EDIT_PLAYER'},
		params: {
			id: {squash: true, value: null}
		},
		resolve: {
			hasPermission: (PlayersFactory, $q, $rootScope, Permissions, $stateParams) => {
				'ngInject';
				let deferred = $q.defer();

				if($rootScope.user.isUserTypeTeam()
					&& $rootScope.user.canDo(Permissions.EDIT_PLAYER)){
					PlayersFactory.getOne($stateParams.id).then(response =>{
						if($rootScope.user.isTeam(response.data.team_id)){
							deferred.resolve();
						}else{
							deferred.reject("Access denied!");
						}
					}).catch(error =>{
						deferred.reject("Access denied!");
					});
				}else if(!$rootScope.user.isUserTypeTeam() && $rootScope.user.canDo(Permissions.EDIT_PLAYER)){
					deferred.resolve();
				}else{
					deferred.reject("Access denied!");
				}

				return deferred.promise;
			}
		}
	});

})
.component('playerEdit', playerEditComponent)
.name;

export default playerEditModule;



// WEBPACK FOOTER //
// ./client/app/components/players/playerEdit/playerEdit.js